import { Link, Outlet } from "react-router-dom";
import React, { useRef } from "react";
import Header from "./header";
import Footer from "./footer";
import Banner from "./banner";
export default function Layout() {
  const formRef = useRef(null);
  return (
    <>
      <Header />
      <Banner formRef={formRef} />
      <main>
        <Outlet context={{ formRef }} />
      </main>

      <Footer />
    </>
  );
}
